(function($) {

	$resourceFilter = $( '#resource-filter' );

	if ( $resourceFilter.length < 1 ) {
		return;
	}

	$( '#resource-filter select' ).on( 'change', handleFilterChange );
	$(document).on( 'ready', handleFilterChange );

	$(document).on( 'click', '.filtered-navigation a', handlePagination );

	function handleFilterChange() {
		var category = $( this ).val();

		if ( ! category ) {
			category = $( '#resource-filter select' ).val();
		}

		var post_per_page = $( this ).closest('section').data('post-per-page');

		data = {
			'action': 'filterresources',
			'category': category,
			'post_per_page': post_per_page
		};
		$.ajax({
			url : localizedData.ajax_url,
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				$('#resource-ajax-spinner').show();
				$('#resource-filter select').attr( 'disabled', 'disabled' );
			},
			success : function( data ) {
				if ( data ) {
					$('.cards-list').html( data.posts );
					$('.post-pagination').html( data.nav );
					$('#resource-filter select').removeAttr('disabled');
					$('#resource-ajax-spinner').hide();
				} else {
					$('.cards-list').html( 'No posts found.' );
					$('#resource-ajax-spinner').hide();
				}
			}
		});
	}

	function handlePagination( e ) {
		e.preventDefault();
		var category = $( this ).closest('nav').data('nav-cat');
		var post_per_page = $( this ).closest('section').data('post-per-page');
		var selected_page = $( this ).attr("href");
		if( selected_page.includes("/page/") ) {
			selected_page = selected_page.match(/\/page\/(\d*)/)[1];
		} else {
			selected_page = '1';
		}

		data = {
			'action': 'filterresources',
			'category': category,
			'post_per_page': post_per_page,
			'paged' : selected_page,
		};

		$.ajax({
			url : localizedData.ajax_url,
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				$('#resource-ajax-spinner').show();
				$('#resource-filter select').attr( 'disabled', 'disabled' );
			},
			success : function( data ) {
				if ( data ) {
					$('.cards-list').html( data.posts );
					$('.post-pagination').html( data.nav );
					$('#resource-filter select').removeAttr('disabled');
					$('#resource-ajax-spinner').hide();
				} else {
					$('.cards-list').html( 'No posts found.' );
					$('#resource-ajax-spinner').hide();
				}
			}
		});
	}
})(jQuery);